const _excluded = ["showTemplatesDivider"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from '@adsk/alloy-react-box';
import Divider from '@adsk/alloy-react-divider';
import { useLocale } from '@adsk/alloy-react-locale';
import { InfoPopover } from '@adsk/alloy-react-tooltip';
import { SideNavigationItem } from '@adsk/alloy-side-navigation';

/**
 * Custom side navigation item to show actual navigation item ("Configuration") along with "Template" header
 */
const ProjectTemplateSettingsSideNavigationItem = _ref => {
  let {
      showTemplatesDivider
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require(`./i18n/${locale}.json`);
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SideNavigationItem, _extends({}, props, {
    style: _objectSpread(_objectSpread({}, props.style), {}, {
      margin: '12px 0'
    })
  })), showTemplatesDivider && /*#__PURE__*/React.createElement(Divider, {
    style: {
      width: 'auto',
      margin: '0 16px'
    }
  }), showTemplatesDivider && !props.collapsed && /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    margin: "16px 14px 12px"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "charcoal800",
    fontWeight: "bold",
    style: {
      textTransform: 'uppercase'
    }
  }, T.translate('TEMPLATE')), /*#__PURE__*/React.createElement(InfoPopover, {
    message: /*#__PURE__*/React.createElement(Box, {
      whiteSpace: "normal"
    }, /*#__PURE__*/React.createElement(Box, {
      fontWeight: "bold",
      marginBottom: "4px"
    }, T.translate('SET_UP_TEMPLATE')), T.translate('SET_UP_TEMPLATE_DESC')),
    placement: InfoPopover.PLACEMENTS.LEFT,
    size: 14,
    style: {
      lineHeight: 0,
      padding: '0 10px'
    }
  })));
};
ProjectTemplateSettingsSideNavigationItem.propTypes = _objectSpread(_objectSpread({}, SideNavigationItem.propTypes), {}, {
  showTemplatesDivider: PropTypes.bool
});
export default ProjectTemplateSettingsSideNavigationItem;
//# sourceMappingURL=ProjectTemplateSettingsSideNavigationItem.js.map